// import React from 'react';
// import SecondNav from "../Navbar/SecondNav";
// import TopNavbar from "../Navbar/TopNavbar";


// function Franchise() {
//   return (
//     <div
//       className="home-page"
//       style={{
//         width: "100%",
//         minHeight: "100vh",
//         backgroundColor: "#f5f5f5",
//       }}
//     >
//       <TopNavbar />
//       <SecondNav />
         
      
    

//     </div>
//   );
// }

// export default Franchise;












import React from 'react';
import { Box, Container,Avatar, Typography, Grid, Button, Card, CardContent, Fade } from '@mui/material';
import { motion } from 'framer-motion'; // For animations
import BusinessIcon from '@mui/icons-material/Business';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import SchoolIcon from '@mui/icons-material/School';
import TopNavbar from '../Navbar/TopNavbar';
import SecondNav from '../Navbar/SecondNav';
import ChatPopup from './ChatPopup';
import Footer from './Footer';

function Franchise() {
  // Animation variants for cards
  const cardVariants = {
    hover: { scale: 1.05, boxShadow: '0px 12px 40px rgba(0, 0, 0, 0.4)' },
    initial: { scale: 1, boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.2)' },
  };

  return (
    <div
      className="franchise-page"
      style={{
        width: '100%',
        minHeight: '100vh',
        backgroundColor: '#f5f5f5',
        position: 'relative',
      }}
    >
      <TopNavbar />
      <SecondNav />

      {/* Hero Section */}
      <Box
        sx={{
          minHeight: '100vh',
          backgroundImage: 'url(https://media.istockphoto.com/id/953587268/photo/man-sitting-in-car-and-texting-on-the-phone-stock-image.jpg?s=612x612&w=0&k=20&c=uW7ZNjg1uOeyqN9MlJMUnfziNLMk9HkLNp9G40wdW4s=)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
          position: 'relative',
          zIndex: 1,
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: 'linear-gradient(to bottom, rgba(0, 0, 0, 0.85), rgba(0, 0, 0, 0.65))',
            zIndex: -1,
          },
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          py: { xs: 12, md: 16 },
          mt: 4,
        }}
      >
        <Container maxWidth="lg">
          <Fade in timeout={1200}>
            <Box sx={{ textAlign: 'center' }}>
              <motion.div
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 1, ease: 'easeOut' }}
              >
                <Typography
                  variant="h2"
                  sx={{
                    fontWeight: 900,
                    mb: 3,
                    fontSize: { xs: '2.5rem', md: '4.5rem' },
                    letterSpacing: '0.03em',
                    background: 'linear-gradient(45deg, #1E88E5, #42A5F5)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    textShadow: '0 4px 8px rgba(0,0,0,0.5)',
                  }}
                >
                  Become a Franchise Partner
                </Typography>
              </motion.div>
              <Typography
                variant="h5"
                sx={{
                  mb: 5,
                  fontWeight: 300,
                  maxWidth: '900px',
                  mx: 'auto',
                  color: '#ddd',
                  opacity: 0.85,
                }}
              >
                Join our dynamic network and bring world-class services to your city with low investment and exceptional returns!
              </Typography>
              <Button
                variant="contained"
                size="large"
                sx={{
                  px: 5,
                  py: 1.5,
                  fontSize: '1.2rem',
                  fontWeight: 700,
                  borderRadius: '50px',
                  backgroundColor: '#fff',
                  color: '#1E88E5',
                  '&:hover': {
                    backgroundColor: '#f0f0f0',
                  },
                }}
                component={motion.button}
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.95 }}
              >
                Apply Now
              </Button>
            </Box>
          </Fade>
        </Container>
      </Box>

      {/* Benefits Section */}
      {/* <Box sx={{ py: { xs: 8, md: 12 }, backgroundColor: '#f5f5f5' }}>
        <Container maxWidth="lg">
          <Typography
            variant="h3"
            textAlign="center"
            gutterBottom
            sx={{
              fontWeight: 800,
              mb: 6,
              background: 'linear-gradient(45deg, #1E88E5, #42A5F5)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
            }}
          >
            Why Partner With Us?
          </Typography>
          <Grid container spacing={4}>
            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', gap: 4, flexWrap: 'wrap' }}>
              {[
                {
                  title: 'Strong Brand Support',
                  description:
                    'Leverage our established brand with comprehensive marketing, operations, and branding support from day one.',
                  icon: '🚀',
                },
                {
                  title: 'Low Investment',
                  description:
                    'Launch your franchise with minimal capital and unlock scalable growth opportunities with our proven model.',
                  icon: '💰',
                },
                {
                  title: 'Training & Guidance',
                  description:
                    'Receive in-depth training and ongoing operational support to ensure a seamless and successful start.',
                  icon: '📚',
                },
              ].map((item, index) => (
                <motion.div
                  key={index}
                  variants={cardVariants}
                  initial="initial"
                  whileHover="hover"
                  transition={{ duration: 0.3 }}
                  style={{ flex: '1 1 300px', maxWidth: '350px' }}
                >
                  <Card
                    sx={{
                      height: '100%',
                      borderRadius: '12px',
                      backgroundColor: 'rgba(255, 255, 255, 0.1)',
                      backdropFilter: 'blur(12px)',
                      border: '1px solid rgba(255, 255, 255, 0.2)',
                      boxShadow: '0 10px 35px rgba(0,0,0,0.35)',
                    }}
                  >
                    <CardContent sx={{ textAlign: 'center', py: 4 }}>
                      <Typography
                        variant="h3"
                        sx={{ fontSize: '2.5rem', mb: 2, color: '#1E88E5' }}
                      >
                        {item.icon}
                      </Typography>
                      <Typography
                        variant="h5"
                        fontWeight="bold"
                        gutterBottom
                        sx={{
                          background: 'linear-gradient(45deg, #1E88E5, #42A5F5)',
                          WebkitBackgroundClip: 'text',
                          WebkitTextFillColor: 'transparent',
                        }}
                      >
                        {item.title}
                      </Typography>
                      <Typography variant="body1" sx={{ color: '#ddd' }}>
                        {item.description}
                      </Typography>
                    </CardContent>
                  </Card>
                </motion.div>
              ))}
            </Grid>
          </Grid>
        </Container>
      </Box> */}

      <Box
  sx={{
    py: { xs: 8, md: 12 },
    backgroundColor: '#f5f5f5',
  }}
>
  <Container maxWidth="lg">
    <Typography
      variant="h3"
      textAlign="center"
      gutterBottom
      sx={{
        fontWeight: 800,
        mb: 6,
        background: 'linear-gradient(45deg, #1E88E5, #42A5F5)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
      }}
    >
      Why Partner With Us?
    </Typography>

    <Grid container spacing={4} justifyContent="center">
      {[
        {
          title: 'Strong Brand Support',
          description:
            'Benefit from a powerful, trusted brand with full support in marketing, branding, and operations.',
          icon: <BusinessIcon sx={{ fontSize: 36, color: '#fff' }} />,
        },
        {
          title: 'Low Investment',
          description:
            'Get started with affordable investment and achieve high returns with our proven franchise model.',
          icon: <AttachMoneyIcon sx={{ fontSize: 36, color: '#fff' }} />,
        },
        {
          title: 'Training & Guidance',
          description:
            'We offer end-to-end training and continuous support to ensure your long-term success.',
          icon: <SchoolIcon sx={{ fontSize: 36, color: '#fff' }} />,
        },
      ].map((item, index) => (
        <motion.div
          key={index}
          variants={{
            initial: { opacity: 0.9 },
            hover: { scale: 1.05 },
          }}
          initial="initial"
          whileHover="hover"
          transition={{ duration: 0.3 }}
          style={{ flex: '1 1 300px', maxWidth: '350px', margin: '20px' }}
        >
          <Card
            sx={{
              borderRadius: '16px',
              background: 'linear-gradient(to right, #e3f2fd, #ffffff)',
              boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)',
              height: '100%',
            }}
          >
            <CardContent sx={{ textAlign: 'center', py: 4 }}>
              <Avatar
                sx={{
                  bgcolor: '#1E88E5',
                  width: 64,
                  height: 64,
                  margin: '0 auto 16px',
                }}
              >
                {item.icon}
              </Avatar>
              <Typography
                variant="h6"
                fontWeight="bold"
                gutterBottom
                sx={{ color: '#1E88E5' }}
              >
                {item.title}
              </Typography>
              <Typography variant="body2" sx={{ color: '#333' }}>
                {item.description}
              </Typography>
            </CardContent>
          </Card>
        </motion.div>
      ))}
    </Grid>
  </Container>
</Box>


      {/* Call to Action */}
      <Box
        sx={{
          background: 'linear-gradient(to bottom, rgba(0, 0, 0, 0.85), rgba(0, 0, 0, 0.65))',
          textAlign: 'center',
          py: 8,
          position: 'relative',
        }}
      >
        <Container maxWidth="md">
          <Typography
            variant="h4"
            gutterBottom
            sx={{
              fontWeight: 800,
              mb: 4,
              background: 'linear-gradient(45deg, #1E88E5, #42A5F5)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
            }}
          >
            Ready to Start Your Franchise Journey?
          </Typography>
          <Button
            variant="contained"
            size="large"
            sx={{
              px: 5,
              py: 1.5,
              fontSize: '1.2rem',
              fontWeight: 700,
              borderRadius: '50px',
              backgroundColor: '#fff',
              color: '#1E88E5',
              '&:hover': {
                backgroundColor: '#f0f0f0',
              },
            }}
            component={motion.button}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.95 }}
          >
            Get in Touch
          </Button>
        </Container>
      </Box>

    

      <ChatPopup />
      <Footer />
    </div>
  );
}

export default Franchise;